import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Shield, AlertTriangle, CheckCircle, BarChart3, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const RiskAssessment = () => {
  const navigate = useNavigate();
  const riskFeatures = [{
    icon: AlertTriangle,
    title: 'Hazard Identification',
    description: 'Comprehensive database of food safety hazards with intelligent categorization and risk scoring.'
  }, {
    icon: Shield,
    title: 'Risk Scoring Matrix',
    description: 'Advanced risk assessment methodology based on likelihood and severity of food safety incidents.'
  }, {
    icon: CheckCircle,
    title: 'Mitigation Strategies',
    description: 'Automated recommendations for risk mitigation with integrated corrective action workflows.'
  }, {
    icon: BarChart3,
    title: 'Risk Analytics',
    description: 'Real-time risk monitoring with trend analysis and predictive insights for proactive management.'
  }];
  const benefits = ['Reduce food safety incidents by up to 85%', 'Streamline audit preparation and compliance reporting', 'Automated risk alerts and escalation procedures', 'Integration with HACCP principles and critical control points', 'Regulatory compliance tracking for FDA, USDA, and international standards'];
  return <div className="min-h-screen">
      <header className="glass-panel-nav">
        <div className="container mx-auto px-4 py-4">
          <Button variant="glass" onClick={() => navigate('/')} className="mb-4 flex items-center gap-2">
            <ArrowLeft className="h-4 w-4" />
            Back to Home
          </Button>
          <h1 className="heading-hero py-[7px] text-center">Strategic Risk Assessment</h1>
          <p className="subheading mt-4 text-center">
            Comprehensive risk analysis and mitigation strategies for food safety operations
          </p>
        </div>
      </header>

      <main className="py-16">
        <div className="container mx-auto px-4">
          {/* Key Features */}
          <section className="mb-16">
            <h2 className="heading-section mb-8 text-center">Key Capabilities</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {riskFeatures.map((feature, index) => {
              const IconComponent = feature.icon;
              return <Card key={feature.title} className="glass-panel border-0 bg-transparent">
                    <CardHeader>
                      <div className="flex items-center gap-4 mb-4">
                        <div className="p-3 rounded-xl bg-crystal-orange/10 border border-crystal-orange/20">
                          <IconComponent className="h-6 w-6 text-crystal-orange" />
                        </div>
                        <CardTitle className="text-white">{feature.title}</CardTitle>
                      </div>
                    </CardHeader>
                    <CardContent>
                      <p className="text-white/70">{feature.description}</p>
                    </CardContent>
                  </Card>;
            })}
            </div>
          </section>

          {/* Benefits Section */}
          <section className="mb-16">
            <div className="glass-panel-elevated p-8">
              <h2 className="heading-section mb-6 text-center">Proven Results</h2>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                <div>
                  <ul className="space-y-4">
                    {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3">
                        <CheckCircle className="h-5 w-5 text-crystal-orange mt-1 flex-shrink-0" />
                        <span className="text-white">{benefit}</span>
                      </li>)}
                  </ul>
                </div>
                <div className="text-center">
                  <div className="glass-panel p-8">
                    <div className="text-4xl font-bold text-crystal-orange mb-2">85%</div>
                    <p className="text-white/70">Reduction in food safety incidents</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="text-center">
            <div className="glass-panel-elevated p-8">
              <h3 className="text-2xl font-bold text-white mb-4">
                Ready to Transform Your Risk Management?
              </h3>
              <p className="text-white/70 mb-6 max-w-2xl mx-auto">
                See how our risk assessment tools can help you identify, analyze, and mitigate food safety risks across your operations.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button className="cta-primary px-8 py-3">
                  Schedule Demo
                </Button>
                <Button className="cta-secondary px-8 py-3">
                  Contact Sales
                </Button>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>;
};
export default RiskAssessment;